const ENDPOINT_SESSIONS_MAP_DATA = '/secure/services/sessions-map-data'

export const state = () => ({
  //  mapFrenchData: {}
})

export const mutations = {
  //  setMapFrenchData(state, payload) {
  //    state.mapFrenchData = payload
  //  }
}

export const getters = {
  //  getMapFrenchData(state) {
  //    return state.mapFrenchData
  //  }
}

export const actions = {
  async fetchMapFrenchData({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SESSIONS_MAP_DATA + '?isOld=false&country=France'
      )
      //      console.log(response)
      //      commit('setMapFrenchData', response.data)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
